import produce from 'immer';
import ActionTypes from './LazyOpen.actions';
import { ActionTypes as HomeActions } from '../home/Home.actions';

export const initialState = {
    files: {},
    editUrls: {},
    attachments: {}
};
const reducer = (state = initialState, action) => produce(state, (draft) => {
    switch (action.type) {
        case ActionTypes.addLoading.File: {
            const { key } = action.payload;
            draft.files[key] = true;
            return draft;
        }
        case ActionTypes.removeLoading.File:
        case HomeActions.fetchFileError: {
            const { key } = action.payload;
            delete draft.files[key];
            return draft;
        }
        case ActionTypes.addLoading.Attachment: {
            const { key } = action.payload;
            draft.attachments[key] = true;
            return draft;
        }
        case ActionTypes.removeLoading.Attachment: {
            const { key } = action.payload;
            delete draft.attachments[key];
            return draft;
        }
        case ActionTypes.addLoading.EditUrl: {
            const { key } = action.payload;
            draft.editUrls[key] = true;
            return draft;
        }
        case ActionTypes.removeLoading.EditUrl: {
            const { key } = action.payload;
            delete draft.editUrls[key];
            return draft;
        }
        default: {
            return state;
        }
    }
});
export default reducer;
